module.exports = __webpack_public_path__ + "img/chevron.562f26c9.svg";